export const collabsTableHead = [
    {
        name: '',
        sortable: false,
    },
    {
        name: 'Number',
        sortable: true,
        order: 'number'
    },
    {
        name: 'Name',
        sortable: true,
        order: 'fname'
    },
    {
        name: 'Address',
        sortable: true,
        order: 'street'
    },
    {
        name: 'Job Title',
        sortable: true,
        order: 'jobTitle'
    },
    {
        name: 'Company',
        sortable: true,
        order: 'company'
    },
    {
        name: 'Website',
        sortable: true,
        order: 'website'
    },
    {
        name: 'Email',
        sortable: true,
        order: 'email'
    },
    {
        name: 'Phone',
        sortable: true,
        order: 'phone'
    },
    {
        name: 'Checkbox',
        sortable: false,
    },
];